import { useEffect } from "react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useOutsideClick = (ref: any, callback: any) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleClick = (e: { target: any }) => {
    if (ref.current && !ref.current.contains(e.target)) {
      callback();
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  });
};

export default useOutsideClick;
